import AOS from 'aos';
import 'aos/dist/aos.css';

export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: false,
    maxItemsVisible: 5,
    isResponsive: false,
    allEventsLink: true,
    allEventsLinkText: 'view full calendar',
    link: 'all',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      let eventsQuantity = data.length;
      if (eventsQuantity == 0) {
        $(`#${widgetName}`).remove();
        $('body').addClass('no-events-loaded');
      } else {
        AOS.init({
          anchorPlacement: 'bottom-bottom',
          animatedClassName: 'aos-animate',
          initClassName: 'aos-init',
        });
        let windowSize = $(window).width();
        let breakpoint = 800;

        $('#multiScheduleFeature').prepend();

        $(`#${widgetName} .featureItem`).each(function (i) {
          $(this).wrap('<div class="featureItemWrapper"></div>');
          $(this).attr({
            'data-aos': 'fade-left',
            'data-aos-easing': 'ease-in-out',
            'data-aos-duration': '400',
            'data-aos-delay': (i + 1) * 300,
            'data-aos-once': 'true',
            'data-aos-offset': '100',
          });
          $(this);

          let widgetDate = data[i].Date;
          let widgetName = data[i].Name;
          let widgetDescription = data[i].Description;
          let widgetURL = data[i].URL;

          let fixedDate = widgetDate.split('-');

          let dayStart;
          let monthStart;
          let dayEnd;
          let monthEnd;
          let dateLayout;

          switch (fixedDate.length) {
            case 1:
              dayStart = formatDate(fixedDate, 0, 0, 1);
              monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
              dateLayout = buildEventDateLayout(monthStart, dayStart);
              break;

            case 2:
              monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
              dayStart = formatDate(fixedDate, 0, 0, 1);
              monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
              dayEnd = formatDate(fixedDate, 1, 0, 1);
              dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
              break;

            default:
              break;
          }

          $(this).empty();
          $(this).append(buildEventInfoLayout(widgetName, widgetDescription));

          if (windowSize > breakpoint) {
            $(this).removeAttr('href');
          }
          if (widgetURL == '') {
            $(this).removeAttr('href');
            $(this).addClass('void');
          }

          $(this).append(dateLayout);
          if (widgetURL != '') {
            $(this).attr('href', widgetURL);
          }
        });

        $('.all-events-btn').addClass('button');
        $('.all-events-btn').appendTo('#multiScheduleFeature');
        $('.all-events-btn').wrap('<div class="btn-container"></div>');

        $(`#${widgetName}`).find('.btn-container').attr({
          'data-aos': 'flip-down',
          'data-aos-easing': 'ease-in-out',
          'data-aos-duration': '1000',
          'data-aos-delay': '1800',
          'data-aos-once': 'true',
          'data-aos-offset': '10',
        });
      }
    },
  });
}

function buildEventInfoLayout(title, description) {
  let infoLayout = `
<div class="overlay-bg"></div>
  <div class="event-info">
    <span class="event-name">${title}</span>
    <span class="event-description">${description}</span>
  </div>`;

  return infoLayout;
}

function formatDate(date, slot1, slot2, slot3) {
  let splittedDate = date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
  return splittedDate;
}

function buildEventDateLayout(
  eventStartMonth,
  eventStartDay,
  eventEndMonth = null,
  eventEndDay = null,
) {
  let dateLayout;
  if (eventEndMonth === null || eventEndDay === null) {
    dateLayout = `
          <div class="event-date ">
              <span class="month">${eventStartMonth}</span>
              <span class="day">${eventStartDay}</span>
          </div>`;
  } else if (eventStartMonth == eventEndMonth) {
    dateLayout = `
          <div class="event-date double-date">
              <span class="month">${eventStartMonth}</span>
              <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
          </div>`;
  } else {
    dateLayout = `
          <div class="event-date date-range">
              <div class="combo-date">
                  <span class="month">${eventStartMonth}</span>
                  <span class="day">${eventStartDay}</span>
                  </div>
                  
              <span class="separator-month">-</span>

              <div class="combo-date">
                  <span class="month">${eventEndMonth}</span>
                  <span class="day">${eventEndDay}</span>
              </div>
          </div>`;
  }
  return dateLayout;
}
